<div class="si-radio {{styleClass}}" [tabindex]="disabled ? '-1' : '0'" [class.disabled]="disabled" siProvideParentForm>
  <input type="radio"
         id="si-radio-{{id}}"
         name="{{name}}"
         [value]="value"
         [ngModel]="model"
         (ngModelChange)="onChangeModel($event)">
  <label for="si-radio-{{id}}">{{text | translate}}</label>
  <div class="si-radio_check"></div>
  <div class="si-radio_check_focus"></div>
</div>
